export default __webpack_public_path__ + "static/find-sponsors-graphic-79ff990749aee797129a6c2b6014a5c5.svg";